<template>
  <div class="progress-bar">
    <div class="progress-bar__content">
      <icon-tick v-if="percentage === 100" />
      <p class="progress-bar__text text-body-s">
        {{ progressText }}
      </p>
    </div>

    <div class="progress-bar__bar">
      <span
        class="progress-bar__bar--filled"
        :style="{ width: `${ percentage }%` }"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Progress Bar (progress-bar)
 * -----------------------------------------------------------------------------
 * Progress bar that can show completion rate up to 100%.
 *
 * @param {Number} percentage - Percentage of the progress bar.
 * @param {String} progressText - Text that shown in progress bar information
 *
 */
import IconTick from '~icons/misc/tick.svg'

export default {
  name: 'ProgressBar',

  components: { IconTick },

  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    progressText: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
@import 'progress-bar';
</style>
